import React from "react";
import { Container, Stack } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";

import Logo from "../../assets/GemX.png";
 import { useSelector } from "react-redux"; 

const AuthLayout = () => {
  const { isLoggedIn } =  useSelector((state) => state.auth) ;

  if (isLoggedIn) {
    return <Navigate to={"/app"} />;
  }

  return (
    <>
    <Container sx={{ mt: 4 }} maxWidth="sm" className="login">
        <Stack spacing={4}>
          <Stack
            sx={{ width: "100%" }}
            direction="column"
            alignItems={"center"}
          >
            <img style={{ height: 120, width: 120 }} src={Logo} alt="Logo" />
          </Stack>
          <Outlet />
        </Stack>
      </Container>
    </>
  );
};

export default AuthLayout;
